var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ib-navigation-button-next',{attrs:{"disabled":_vm.isStartBtnDisable,"text":_vm.buttonText,"title":_vm.buttonTitle},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }